<template>
  <div id="parentx-demo-2">
    <div v-if="profileObject && profileObject.customer">
      <customer-knowledge-popup
          :is-active="isActivePopupknowledge"
          :current-know="currentKnow"
          :customer-id="profileObject.customer.id"
          @knowledgeClose="popupKnowledge()"
      ></customer-knowledge-popup>
    </div>

    <vs-popup title="Adicionar Categoria" :active.sync="addGroupPopupActive" class="sizePopup">
      <table-category-of-customer 
        :groups="groupsOfCustomerAvailable" 
        :addGroupPopupActive="addGroupPopupActive" 
        @saveGroupsOnCustomer="attachGroupsOnCustomer"
      />
    </vs-popup>

    <chosen-instance-pop-up
        :is-read-only="true"
        :is-cloud-only="true"
        :is-active="activeChosen"
        :active-instances="chosenInstances"
        @close="activeChosen = false"
        @chosen-instances="selected"
    />

    <vs-sidebar parent="#chat-app" :position-right="!isLoggedInUser" :hidden-background="false" v-model="activeLocal"
      id="chat-profile-sidebar" class="items-no-padding">
        <div v-if="profileObject != null" class="header-sidebar relative flex flex-col p-0" slot="header">
          <feather-icon icon="XIcon" svgClasses="m-2 cursor-pointer absolute top-0 right-0" @click="closeWindow()"></feather-icon>

          <div class="relative inline-flex mx-auto mb-5 mt-6">
            <vs-avatar class="m-0 border-white border-2 border-solid shadow-md" :src="profileObject.customer.image" size="70px" />
          </div>

          <div class="text-center">
            <div>
              <h4 v-if="!canSeeInputName" class="mr-2 self-center inline" id="nameField">{{ profileObject.customer.name }}</h4>
              <input
                id="inputNewName"
                v-else
                v-model="customerData.name"
                type="text"
                class="vs-inputx vs-input--input normal hasValue w-1/2 m-1"
              />
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click="canSeeInputName=!canSeeInputName"
              />
            </div>
            <div class="flex justify-content-center">
              <p v-if="!canSeeInputPhone" class="mr-2 self-center inline" id="phoneField">{{ maskedPhone }}</p>
              <vx-input-phone
                v-else
                type="text"
                id="inputNewPhone"
                class="w-4/5 m-1"
                v-model="customerData.phone_number"
                :reload="activeLocal"
                :preferredCountries="['BR']"
                :noUseBrowserLocale="true"
                @update="setInternational"
                v-validate="'required'"
              />

              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click="canSeeInputPhone=!canSeeInputPhone"
                style="display: inline !important; align-self: center"
              />
            </div>
          </div>
        </div>

        <VuePerfectScrollbar 
          id="infinite-tickets-list" 
          class="scroll-area" 
          ref="customerTicketsScrollBar" 
          :settings="settings"
        >
          <div v-if="profileObject != null" class="relative flex flex-col mt-2 mr-8 ml-8 mr-8" :key="componentKey">
            <vs-tabs v-model="openTab" alignment="center">
              <vs-tab label="" icon="subject">
                  <h4 class="text-gray"> Informações </h4>
                  <div class="w-full mt-5 mb-5">
                      <span>Dados adicionais</span>
                      <vs-textarea v-model="customerData.open_field" />

                      <div class="flex" style="text-align: -webkit-center;">
                          <div v-if="canSee('favorite')" class="w-full mt-1 mb-1">
                              <label for class="vs-input--label">Favorito</label>
                              <vs-switch v-model="customerData.is_favorite"/>
                          </div>

                          <div class="w-full mt-1 mb-1">
                              <label for class="vs-input--label">Bloqueado da Campanha</label>
                              <vs-switch v-model="customerData.is_blacklisted"/>
                          </div>
                      </div>
                  </div>
              </vs-tab>

              <vs-tab label="" icon="icon-grid" icon-pack="feather">
                  <h4 class="mb-5 text-gray"> Categoria do Contato </h4>
                  <div class="w-full mt-5 mb-5">
                      <p v-if="!customerGroups.length" class="mt-2">Nenhuma categoria vinculada.</p>

                      <vs-chip
                        class="mt-3 mr-3" style="font-size: 0.9rem;"
                        :key="`customer-group-${index}`"
                        @click="removeGroup(customerGroup)"
                        v-for="(customerGroup, index) in customerGroups" closable :color="customerGroup.group.color_tag"
                      >
                        {{ customerGroup.group.name }}
                      </vs-chip>

                      <vs-chip @click="addGroups" closable close-icon="add" class="mt-3 mb-5 mr-3" style="font-size: 0.9rem;">
                          Adicionar Categoria
                      </vs-chip>
                  </div>
              </vs-tab>

              <vs-tab label=""  icon="icon-message-square" icon-pack="feather" v-if="instance && instance.is_official === true">
                  <div class="flex w-full">
                    <h4 class="mb-5 text-gray ml-5"> Atendimentos </h4>
                    <vx-tooltip class="ml-3 text-right" text="Filtrar por conexão" v-if="unifyConnections">
                      <vs-button color="primary" size="small" type="border" icon-pack="feather" icon="icon-search" @click.prevent="activeChosen = true" ></vs-button>
                    </vx-tooltip>
                  </div>

                  <div class="w-full">
                      <vs-collapse type="margin" class="p-0">
                          <vs-collapse-item :open="true">
                              <div slot="header"> Abertos ({{chatTicketsOpen.length}})</div>
                              <ticket-cost-infos :chat-ticket-cost="chatTicketsOpen"></ticket-cost-infos>
                          </vs-collapse-item>
                          <vs-collapse-item :open="false">
                              <div slot="header"> Fechados ({{chatTicketsClose.length}})</div>
                              <ticket-cost-infos :chat-ticket-cost="chatTicketsClose"></ticket-cost-infos>
                          </vs-collapse-item>
                          <vs-collapse-item :open="false">
                              <div slot="header"> Total Gasto </div>

                              <div class="ml-5">
                                  <b>Tipos de custo</b>
                                  <li> Iniciados: {{ maskMoney(sumTypeCosts['costs_by_business'], 'BRL', 1) }} </li>
                                  <li> Transacionais: {{ maskMoney(sumTypeCosts['costs_by_utility'], 'BRL', 1) }} </li>
                                  <li> Recebidos: {{ maskMoney(sumTypeCosts['costs_by_user'], 'BRL', 1) }} </li>
                              </div>
                          </vs-collapse-item>
                      </vs-collapse>
                  </div>
              </vs-tab>

              <vs-tab label="" class="p-0 custormer-extras-tab" icon="icon-book-open" icon-pack="feather">

                <vs-collapse id="col-customer-extra-data" data-testid="collapse-user-proile" class="p-0" type="margin" accordion>
                  <vs-collapse-item>
                    <div slot="header">
                      Modelo de Dados do Cliente
                    </div>

                    <vs-list v-if="knowledge.length > 0">
                      <vs-list-item v-for="(tr, idx) in knowledge" :key="idx" :title="tr.description">
                        <vs-button color="primary" type="flat" icon-pack="feather" icon="icon-maximize-2" @click="popupKnowledge(tr)"></vs-button>
                      </vs-list-item>
                    </vs-list>
                    
                    <vs-list v-else>
                      <vs-list-item title="Nenhum modelo cadastrado." subtitle="Acesse Modelo de Dados do Cliente para cadastrar."></vs-list-item>
                    </vs-list>
                  </vs-collapse-item>

                  <vs-collapse-item class="collapse-item">
                    <div slot="header">
                      Métricas Inteligentes e Encerramentos
                    </div>
                    
                    <span class="mb-2" v-if="hasCustomerTicketData" @click="orderByOldersFirstTickets=!orderByOldersFirstTickets">
                      <strong style="font-size: 15.7px;">Histórico:</strong>
                      <feather-icon
                        :icon="orderByOldersFirstTickets ? 'ArrowDownIcon' : 'ArrowUpIcon'"
                        svgClasses="w-5 h-4 hover:text-primary stroke-current"
                      />
                    </span>
                
                    <div
                      v-if="hasCustomerTicketData"
                      class="contact__avatar mb-4 pb-3 mt-2 p-2 main-customer-tickets" 
                      v-for="(ticket, index) in customerLastTickets" 
                      :key="index" 
                      style="position: relative;"
                    >
                      <vs-button
                        type="flat"
                        icon-pack="feather"
                        icon="icon-maximize-2"
                        @click="openFinishedTicketModal(getReasonInfo(ticket), ticket)"
                        class="sticky-button p-0"
                      />

                      <div style="margin-right: 10px;" class="pt-4" v-if="ticket && ticket.user && ticket.user.image">
                        <vs-avatar
                          class="border-2 border-solid border-white select-none"
                          :src="ticket.user.image"
                          size="60px"
                        />
                      </div>
                      <div v-else>
                        <vs-avatar
                          class="border-2 border-solid border-white select-none"
                          size="60px"
                        />
                      </div>

                      <div>
                        <div class="pt-4">- Encerrado por: <strong>{{ ticket.is_auto_finished ? 'Pedbot' : (ticket.user && ticket.user.name ? ticket.user.name : 'Removido') }}</strong></div>
                        <div>- Tipo da Métrica: <strong>{{ getReasonInfo(ticket) ? getReasonInfo(ticket).content.title : 'Não informado' }}</strong></div>
                        <div>- Encerramento: <strong>{{ formatDate(ticket.finished_at) }}</strong></div>
                        <div v-if="ticket.instance && ticket.instance.name">- Conexão: <strong>{{ ticket.instance.name }}</strong></div>
                      </div>
                    </div>

                    <div v-if="!hasCustomerTicketData" class="mt-2">
                      <vs-divider>
                        Sem dados disponíveis
                      </vs-divider>
                    </div>
                    <vs-pagination
                      v-else
                      :total="totalPagesOfTickets"
                      v-model="pageOfTickets"
                      :max="6"
                    />
                    <div style="height: 30px;"></div>

                  </vs-collapse-item>

                  <vs-collapse-item class="collapse-item">
                    <div slot="header">
                      Transferências
                    </div>

                    <span class="mb-2" v-if="hasTicketTransfer" @click="orderByOldersTransfers=!orderByOldersTransfers">
                      <strong style="font-size: 15.7px;">Histórico:</strong>
                      <feather-icon
                        :icon="orderByOldersTransfers ? 'ArrowDownIcon' : 'ArrowUpIcon'"
                        svgClasses="w-5 h-4 hover:text-primary stroke-current"
                      />
                    </span>

                    <div
                      v-if="hasTicketTransfer"
                      class="contact__avatar mb-4 pb-3 mt-2 p-2 main-customer-tickets" 
                      v-for="(transfer, index) in ticketTransfers" 
                      :key="index" 
                      style="position: relative;"
                    >
                      <!--
                      <vs-button
                        type="flat"
                        icon-pack="feather"
                        icon="icon-maximize-2"
                        @click="openFinishedTicketModal(getReasonInfo(ticket), ticket)"
                        class="sticky-button p-0"
                      />-->

                      <div style="margin-right: 10px;" class="pt-4" v-if="transfer.previousUser !== null || transfer.nextUser !== null">
                        <vs-avatar
                          class="mt-4 border-2 border-solid border-white select-none"
                          :src="transfer.previousUser === null ? transfer.nextUser.image : (transfer.nextUser === null ? transfer.previousUser.image : transfer.nextUser.image)"
                          size="50px"
                        />
                      </div>
                      <div v-else>
                        <vs-avatar
                          class="border-2 border-solid border-white select-none"
                          size="50px"
                        />
                      </div>

                      <div class="mt-0">
                        <div>-<span class="text-sm"> Foi Puxado: </span> <strong> {{ transfer.pulled || transfer.previousUser === null ? 'SIM' : 'NÃO' }} </strong></div>
                        <div>-<span class="text-sm"> Usuário Anterior: </span> <strong> {{ transfer.previousUser === null ? 'Caixa de Entrada' : transfer.previousUser.name }} </strong></div>
                        <div>-<span class="text-sm"> Usuário Posterior: </span> <strong> {{ transfer.nextUser === null ? 'Caixa de Entrada' : transfer.nextUser.name }} </strong></div>
                        <div>-<span class="text-sm"> Departamento: </span> <strong> {{ transfer.userDepartment === null ? '---' : transfer.userDepartment.name }} </strong></div>
                        <div>-<span class="text-sm"> Transferido em: </span> <strong> {{ formatDate(transfer.transferred_at) }} </strong></div>
                      </div>
                    </div>

                    <div v-if="!hasTicketTransfer" class="mt-2">
                      <vs-divider>
                        Sem dados disponíveis
                      </vs-divider>
                    </div>

                    <vs-pagination
                      v-else
                      class="mt-5"
                      :total="totalPagesOfTransfers"
                      v-model="pageOfTransfers"
                      :max="6"
                    />
                    <div style="height: 30px;"/>
                  </vs-collapse-item>
                </vs-collapse>
                
              </vs-tab>

              <vs-button
                type="filled"
                v-if="openTab !== 2 && openTab !== 3"
                class="bg-primary-gradient w-full mt-5"
                @click="updateOpenField"
                :disabled="isSaving"
              >
                Salvar
              </vs-button>
            </vs-tabs>
          </div>
        </VuePerfectScrollbar>
      </vs-sidebar>
    </div>
</template>

<script>
import customerApi from '@/http/requests/customer';
import knowledgeApi from '@/http/requests/reasons';
import {CustomerService} from "@/db/customer_service";
import {knowledgeType} from "@/supports/reasonSupport";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moduleCustomer from '@/store/customer/moduleCustomer';
import ticketTransferApi from '@/http/requests/ticketTransfer';
import VxInputPhone from "@/components/vx-input-phone/index.vue";
import ChosenInstancePopUp from "../instances/ChosenInstancePopUp.vue";
import CustomerKnowledgePopup from "./services/CustomerKnowledgePopup.vue";
import TicketCostInfos from "@/components/attendance/ticket-cost-infos.vue";
import moduleCustomerGroup from '@/store/customerGroup/moduleCustomerGroup';
import TableCategoryOfCustomer from '@/views/customers/TableCategoryOfCustomer';
import moduleChatTicketCosts from "@/store/chatTicketCosts/moduleChatTicketCosts";

import {
  decodeFromBase64,
  maskPhoneNumber,
  encodeToBase64,
  instanceObject,
  hasPermission,
  maskMoney,
  hasFeature
} from "@/utils";

export default {
  props: {
    profileObject: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null
    },
    active: {
      type: Boolean,
      required: true,
    },
    isLoggedInUser: {
      type: Boolean,
      required: true
    },
    isLocalActiveKnowPopup: {
      type: Boolean,
    }
  },
  emits: [
    'openActiveChatUser'
  ],
  watch: {
    async active(value) {
      this.componentKey++
      this.openTab = 0

      if (value) {
        await this.getCustomerById();
        this.getTicketTransfers();
        this.getCustomerLastChatInfo();
        return;
      }

      this.customerData = {
        id: '',
        name: '',
        open_field: '',
        is_favorite: '',
        phone_number: '',
        is_blacklisted: '',
        international_phone_number: ''
      }
    },
    addGroupPopupActive(val) {
      if (!val) { return; }

      const removeIds = this.customerGroups.map(cg => cg.group.id)
      this.$store.dispatch("customerGroup/fetchDiffGroupsOfCustomer", removeIds).then(res => {
        const { groupsOfCustomer } = res.data.data
        this.groupsOfCustomerAvailable = groupsOfCustomer.map(group => ({
          id: null,
          group
        }))
      }).catch(err => { console.error(err)});
    },
    pageOfTickets() {
      this.$vs.loading({
        container: '#col-customer-extra-data',
        scale: 0.6
      })
      this.getCustomerLastChatInfo();
    },
    pageOfTransfers() {
      this.$vs.loading({
        container: '#col-customer-extra-data',
        scale: 0.6
      })
      this.getTicketTransfers();
    },
    orderByOldersFirstTickets() {
      this.$vs.loading({
        container: '#col-customer-extra-data',
        scale: 0.6
      })

      if (this.page === 1) {
        this.getCustomerLastChatInfo();
      }
      else {
        this.page = 1;
      }
    },
    orderByOldersTransfers() {
      this.$vs.loading({
        container: '#col-customer-extra-data',
        scale: 0.6
      })

      if (this.page === 1) {
        this.getTicketTransfers();
      }
      else {
        this.page = 1;
      }
    },
    canSeeInputPhone(value) {
      if (!value) this.customerData.phone_number = this.oldPhoneNumber;
    }
  },
  data() {
    return {
      openTab: 0,
      componentKey:0,
      canSeeInputName: false,
      canSeeInputPhone: false,
      activeKnowPopup: false,
      activeChosen: false,
      instanceIds: [],
      currentKnow: null,
      groupsToRemove: [],
      knowledge: [],
      customerData: {
        id: '',
        name: '',
        open_field: '',
        is_favorite: '',
        phone_number: '',
        is_blacklisted: '',
        international_phone_number: ''
      },
      settings: {
        maxScrollbarLength: 60
      },
      cService: null,
      customerGroups: [],
      addGroupPopupActive: false,
      groupsOfCustomerAvailable: [],
      oldPhoneNumber: '',
      changedPhone: false,
      isSaving: false,
      isLocalActiveKnowPopup: this.activeKnowPopup,
      customerLastTickets: [
        {
          grade_at: '',
          closed_by: '',
          finished_at: '',
          reasonResponse: null,
          instance: {name: ''},
          is_auto_finished: false,
          user: {name: '', image: ''},
          send_finished_message: false,
          finished_message_is_sent: false
        }
      ],
      ticketTransfers: [],
      pageOfTickets: 1,
      pageOfTransfers: 1,
      totalPagesOfTickets: 1,
      totalPagesOfTransfers: 1,
      orderByOldersFirstTickets: false,
      orderByOldersTransfers: true
    }
  },
  methods: {
    maskMoney,
    canSee(action) {
      return hasPermission(`${this.$route.name}-${action}`)
    },
    async getCustomerLastChatInfo() {
      await customerApi.getCustomerTicketsSummary(this.customerData.id, this.pageOfTickets, this.orderByOldersFirstTickets ? 'ASC' : 'DESC')
      .then (
        response => {
          this.customerLastTickets = response.data.data.chatTicketSummary.items;
          this.totalPagesOfTickets = response.data.data.chatTicketSummary.total_pages;
          this.$vs.loading.close('#col-customer-extra-data > .con-vs-loading');
        }
      ).catch( () => {this.$vs.loading.close('#col-customer-extra-data > .con-vs-loading');} );
    },
    setInternational(phone) {
      if (phone && phone.e164){
        this.customerData.international_phone_number = phone.e164.replace('+', '')
      }
    },
    async getTicketTransfers() {
      await ticketTransferApi.fetchByCustomerId(this.customerData.id, this.pageOfTransfers, 3, this.orderByOldersTransfers ? 'DESC': 'ASC' )
      .then(  
        response => {
          this.ticketTransfers = response.data.data.ticketTransferByCustomerId.items;
          this.totalPagesOfTransfers = response.data.data.ticketTransferByCustomerId.total_pages;
          this.$vs.loading.close('#col-customer-extra-data > .con-vs-loading');
        }
      ).catch( () => {this.$vs.loading.close('#col-customer-extra-data > .con-vs-loading');} );
    },
    openFinishedTicketModal(reason, chatTicket) {
      this.$events.fire('setReasonFromUsersProfile', reason, chatTicket);
    },
    formatDate(dateTimeString) {
      const date = new Date(dateTimeString);
      const formattedDate = `${date.getDate()}/${date.getMonth() + 1}/${date
        .getFullYear()
        .toString()
        .slice(2)}`;
      const formattedTime = `${date.getHours()}:${date.getMinutes()}`;

      return `${formattedDate} às ${formattedTime}`;
    },
    getReasonInfo(data) {
      if (!data.reasonResponse) { return null };
      return JSON.parse(data.reasonResponse);
    },
    async getCustomerById() {
      this.customerData   = await this.cService.getById(this.profileObject.customer.id);
      this.customerData   = this.customerData[0];
      this.oldPhoneNumber = this.customerData.phone_number;
      this.openTab        = 0;
      this.fetchCustomerGroups();

      if ( this.instance && this.instance['is_official'] ){
        this.fetchTicketCosts();
      }

      this.fetchKnowledge()

      try {
        let openFielDecode = decodeFromBase64(this.customerData.open_field)
        this.customerData.open_field = openFielDecode !== 'null' ? openFielDecode : '';
      } catch (error) {
        console.error(error)
      }
    },
    fetchCustomerGroups() {
      this.$store.dispatch("customerGroup/fetchCustomerGroups", this.profileObject.customer.id).then(res => {
        this.customerGroups = res.data.data.customerGroups
      }).catch(err => { console.error(err) })
    },
    fetchTicketCosts(){
      this.$store.dispatch("chatTicketCosts/fetch", {
        'created_by_web' : false,
        'customer_id'    : this.profileObject.customer.id,
        'instance_ids'   : (this.chosenInstances.map((instance) => { return instance.id }))
      }).then().catch(err => { console.error(err) })
    },
    fetchKnowledge() {
      this.knowledge = [];
      knowledgeApi.fetch({deleted: false, type: knowledgeType})
        .then((response) => { this.knowledge = response.data.data.reasons; })
        .catch((error) => { console.error(error) })
    },
    updateOpenField() {
      this.isSaving = true;
      this.isLocalActiveKnowPopup = false

      const customer = this.$_.cloneDeep(this.customerData)
      const chosenGroups = this.customerGroups.map(({ group }) => group.id);

      if (customer.international_phone_number != null) {
        customer.phone_number = customer.international_phone_number;
        delete customer.international_phone_number;
      }

      this.changedPhone = (this.oldPhoneNumber !== this.customerData.phone_number);
      customer.group_of_customer = this.customerGroups.map(({group}) => ({
        name: group.name,
        color_tag: group.color_tag,
      }));

      customer.open_field = encodeToBase64(customer.open_field != null ? customer.open_field : '')
      customer.is_blacklisted = Number(customer.is_blacklisted);
      customer.is_favorite = Number(customer.is_favorite);

      this.cService.update(customer, true)

      customerApi.updateOpenField({ customer, chosenGroups }).then(() => {
        this.$emit('closeProfileSidebar', false)
        this.$emit('reloadChatTab')
        this.$emit('updateChatNavbarWithNewData', customer);
        this.$emit('openActiveChatUser', customer, this.changedPhone);

        this.canSeeInputName = false;
        this.canSeeInputPhone = false;
        this.groupsToRemove.forEach(group => {
        this.$store.dispatch("customerGroup/deleteCustomerGroup", group.id).then(() => {
          this.customerGroups.splice(this.customerGroups.indexOf(group), 1);
        }).catch(err => {
          console.error(err);
        });
      });

      this.groupsToRemove = [];
        this.$vs.notify({
          color: 'success',
          title: 'Sucesso!',
          text: 'Informações atualizadas com sucesso!'
        })
        setTimeout(() => {
          this.isSaving = false;
        }, 1000);
      }).catch(err => { console.error(err) })
    },
    closeWindow() {
      this.canSeeInputName = false;
      this.canSeeInputPhone = false;
      this.groupsToRemove = [];
      this.$emit('closeProfileSidebar', false);
      this.isSaving = false;
    },
    attachGroupsOnCustomer(selectedGroups) {
      this.addGroupPopupActive = false
      this.customerGroups = [
        ...this.customerGroups,
        ...selectedGroups
      ]
    },
    addGroups() {
      this.addGroupPopupActive = true
    },
    removeGroup(group) {
      if (group.id) {
        this.groupsToRemove.push(group);
        this.customerGroups.splice(this.customerGroups.indexOf(group), 1);
      } 
    },
    selected(listIds){
      this.instanceIds = listIds;
      this.fetchTicketCosts()
    },
    closeChosen(){
      this.activeChosen = false
    },
    popupKnowledge(know = null){
      this.currentKnow = null;
      if (know && know.id) {
        this.$store.state.activeKnowPopupVariable = true
        this.currentKnow = know;
        this.activeKnowPopup = this.$store.state.activeKnowPopupVariable;
      } else {
        this.$store.state.activeKnowPopupVariable = false
        this.currentKnow = null;
        this.activeKnowPopup = this.$store.state.activeKnowPopupVariable;
      }
    }
  },
  computed: {
    activeLocal: {
      get() {
        return this.active
      },set() {}
    },
    maskedPhone() {
      return maskPhoneNumber(this.profileObject.customer.phone_number)
    },
    instance(){
      return this.profileObject ? instanceObject(this.profileObject.instance_id) : null
    },
    chatTicketsOpen(){
      return this.$store.state.chatTicketCosts.chatTicketsOpen || null;
    },
    chatTicketsClose(){
      return this.$store.state.chatTicketCosts.chatTicketsClose || null;
    },
    sumTypeCosts(){
      return this.$store.state.chatTicketCosts.sumTypeCosts || null;
    },
    unifyConnections(){
      return this.$store.state.settings.settings.unify_connections !== undefined && !!parseInt(this.$store.state.settings.settings.unify_connections);
    },
    chosenInstances(){
      const chosen = this.$store.state.instance.instances.filter(instance => this.instanceIds.includes(instance.id))
      return chosen.length > 0 ? chosen : [this.instance]
    },
    hasCustomerTicketData() {
      return !(this.customerLastTickets.length === 0);
    },
    hasTicketTransfer() {
      return !(this.ticketTransfers.length === 0);
    },
    isActivePopupknowledge() {
      return this.$store.state.activeKnowPopupVariable
    }
  },
  created() {
    this.activeKnowPopup = false
    this.cService = new CustomerService();

    this.$events.on('closeAllPopUps', this.closeChosen);
    this.$events.on('closeAllPopUps', this.popupKnowledge);

    if (!moduleCustomer.isRegistered) {
      this.$store.registerModule('customer', moduleCustomer);
      moduleCustomer.isRegistered = true;
    } 

    if (!moduleCustomerGroup.isRegistered) {
      this.$store.registerModule('customerGroup', moduleCustomerGroup)
      moduleCustomerGroup.isRegistered = true
    }

    if (!moduleChatTicketCosts.isRegistered) {
      this.$store.registerModule('chatTicketCosts', moduleChatTicketCosts)
      moduleChatTicketCosts.isRegistered = true
    }
  },
  beforeDestroy() {
    this.$events.off('closeAllPopUps', this.closeChosen);
    this.$events.off('closeAllPopUps', this.popupKnowledge);
  },
  components: {
    VxInputPhone,
    TicketCostInfos,
    VuePerfectScrollbar,
    ChosenInstancePopUp,
    CustomerKnowledgePopup,
    TableCategoryOfCustomer
  }
}

</script>
<style lang="scss">

#chat-profile-sidebar {
  .vs-sidebar--items {
    overflow: auto !important;
  }
  .text-gray{
    color: #626262 !important
  }
  section {
    height: 100%;
  }

  .vs-component.vs-con-input-label.vs-input.w-1\/2.m-1.vs-input-primary {
      display: inline-block;
  }

  #button-update-beta {
    transform: translateY(-0.6em);
  }
  i.feather.icon-grid.vs-icon-primary {
      font-size: 20px;
  }
  i.feather.icon-message-square.vs-icon-primary {
      font-size: 20px;
  }
  i.feather.icon-book-open.vs-icon-primary {
    font-size: 20px;
  }
}

.custormer-extras-tab .collapse-item .con-content--item {
  padding: 0 !important; 
}

.main-customer-tickets {
  display: flex; 
  align-items: flex-start; cursor: initial; 
  background-color: #f6f6f6; 
  border-radius: 7px;
  border: 1px solid #e1e1e1;

  .sticky-button {
    position: absolute;
    right: -.2em;
    top:10.5%;
    transform: translateY(-50%);
    transition: 0s !important;
    
    i{
      font-size: 1.3em;
    }
  }
  .sticky-button:hover {
    color: rgb(0, 106, 187);
    background: none !important;
    transition: 0s !important;
  }
}

</style>
